/**
 * Privacy & encryption trust section for the landing page.
 * Thin wrapper around the generic CenteredIconSection component.
 */

import type { ReactNode } from "react";

import { CenteredIconSection } from "~/components/ui/centered-icon-section";

const trustItems = [
  { iconName: "lock" as const, label: "Encrypted before it is stored" },
  { iconName: "eye-off" as const, label: "You choose who reads it" },
  { iconName: "shield" as const, label: "NOVA only when it is turned on" },
];

export function PrivacySection(): ReactNode {
  return (
    <CenteredIconSection
      preHeadline="Your Privacy"
      headline="Your dreams are yours alone."
      description="Your life vision, goals and session notes are encrypted before they are stored, so not even DCM can read them, and you choose who can. NOVA, our AI, can read a program's notes and goals only when your coach turns her on for that program, to help make your coaching better, and every read is logged."
      items={trustItems}
      tone="purple"
    />
  );
}
